import { render, staticRenderFns } from "./DashboardRecapRo.vue?vue&type=template&id=041aeacd&"
import script from "./DashboardRecapRo.vue?vue&type=script&lang=js&"
export * from "./DashboardRecapRo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports